import React from "react";
import { config } from "../config";

const P = ({ children }) => <p style={{ color: "var(--text-muted)", marginBottom: 16 }}>{children}</p>;
const H = ({ children }) => <h2 className="display" style={{ fontSize: 20, marginTop: 32, marginBottom: 12, textTransform: "uppercase", letterSpacing: "0.02em" }}>{children}</h2>;

const PAGES = {
  mentions: {
    title: "MENTIONS LÉGALES.",
    body: (
      <>
        <H>Éditeur</H>
        <P>CRUSH – Dentifrice solide et hygiène dentaire · SIRET 90336261400021 · Responsable de la publication : Fanny Rambaud · Domiciliation « Votre Siège Social », 1 Rue Marguerin, 75014 Paris · Email : {config.brand.contact_email}.</P>
        <H>Hébergement</H>
        <P>Le site est hébergé par [Hébergeur — raison sociale et adresse à compléter]. Mention légalement obligatoire à renseigner avant mise en ligne.</P>
        <H>Propriété intellectuelle</H>
        <P>L'ensemble des contenus (textes, visuels, logos) est la propriété de CRUSH. Toute reproduction sans autorisation est interdite.</P>
        <H>Données personnelles (RGPD)</H>
        <P>Les données collectées lors d'une commande sont traitées conformément au RGPD. Voir notre page Confidentialité.</P>
        <H>Cookies</H>
        <P>Des cookies de mesure d'audience sont déposés uniquement après consentement.</P>
        <H>Responsabilité</H>
        <P>CRUSH ne saurait être tenue responsable des dommages indirects liés à l'utilisation du site.</P>
      </>
    ),
  },
  cgv: {
    title: "CONDITIONS GÉNÉRALES DE VENTE.",
    body: (
      <>
        <H>Article 1 — Vendeur</H>
        <P>CRUSH – Dentifrice solide et hygiène dentaire, SIRET 90336261400021, 1 Rue Marguerin, 75014 Paris. Contact : {config.brand.contact_email}.</P>
        <H>Article 2 — Produits</H><P>Les produits proposés sont ceux figurant sur le site, dans la limite des stocks disponibles.</P>
        <H>Article 3 — Prix</H><P>Les prix sont indiqués en euros toutes taxes comprises (TTC).</P>
        <H>Article 4 — Commandes</H><P>La commande est validée après paiement. Un email de confirmation est envoyé.</P>
        <H>Article 5 — Paiement</H><P>Le paiement est assuré par notre prestataire Stripe. Les coordonnées bancaires sont traitées exclusivement par Stripe.</P>
        <H>Article 6 — Livraison</H><P>Livraison en France métropolitaine sous 5 à 7 jours ouvrés après expédition (48 h).</P>
        <H>Article 7 — Rétractation</H><P>Vous disposez de 14 jours pour vous rétracter, sauf produits d'hygiène descellés (exception art. L.221-28 du Code de la consommation).</P>
        <H>Article 8 — Garanties légales</H><P>Les garanties légales de conformité et des vices cachés s'appliquent.</P>
        <H>Article 9 — Responsabilité</H><P>La responsabilité de CRUSH est limitée au montant de la commande.</P>
        <H>Article 10 — Données</H><P>Voir notre politique de confidentialité.</P>
        <H>Article 11 — Droit applicable</H><P>Les présentes CGV sont soumises au droit français.</P>
      </>
    ),
  },
  livraison: {
    title: "LIVRAISON & RETOURS.",
    body: (
      <>
        <H>Zones de livraison</H><P>France métropolitaine. Europe sur demande.</P>
        <H>Délais</H><P>Préparation sous 48 h, livraison sous 5 à 7 jours ouvrés via Colissimo, Mondial Relay ou Chronopost. Suivi communiqué par email.</P>
        <H>Frais de livraison</H><P>Livraison offerte sur le kit. Sinon 4,90 €, offerte dès 40 € d'achat.</P>
        <H>Retours</H><P>Droit de rétractation de 14 jours (hors produits d'hygiène descellés). Retour accepté sous 30 jours si le produit n'est pas ouvert. Adresse de retour : CRUSH – 1111 Route de Noirétable, 42990 Saint-Just-en-Bas. Remboursement sous quelques jours après inspection. Frais de retour à la charge du client, sauf produit défectueux.</P>
        <H>Garantie</H><P>Satisfait ou remboursé 30 jours.</P>
      </>
    ),
  },
  confidentialite: {
    title: "CONFIDENTIALITÉ.",
    body: (
      <>
        <H>Catégories de données</H><P>Nom, adresse de livraison, email, historique de commande.</P>
        <H>Finalités</H><P>Traitement des commandes, livraison, service client, mesure d'audience (après consentement).</P>
        <H>Prestataires</H><P>Stripe (paiement — les coordonnées bancaires sont traitées exclusivement par Stripe), notre hébergeur, ainsi que GA4, Meta et TikTok pour la mesure d'audience — activés uniquement après votre consentement.</P>
        <H>Vos droits (RGPD/EEE)</H><P>Accès, rectification, effacement, portabilité, opposition. Contact : {config.brand.contact_email}.</P>
        <H>Conservation</H><P>Les données sont conservées le temps nécessaire aux obligations légales et commerciales.</P>
        <H>Mineurs</H><P>Le site ne s'adresse pas aux mineurs de moins de 15 ans.</P>
        <H>Réclamation</H><P>Vous pouvez introduire une réclamation auprès de la CNIL.</P>
        <H>Transferts hors UE</H><P>Certains prestataires peuvent traiter des données hors UE, avec les garanties appropriées.</P>
      </>
    ),
  },
};

export default function Legal({ page }) {
  const p = PAGES[page];
  return (
    <main data-testid={`legal-${page}`} className="section" style={{ minHeight: "60vh" }}>
      <div className="wrap" style={{ maxWidth: 760 }}>
        <h1 className="title-xl" style={{ fontSize: "clamp(30px,6vw,48px)" }}>{p.title}</h1>
        <div style={{ marginTop: 24 }}>{p.body}</div>
      </div>
    </main>
  );
}
